module.exports = __webpack_public_path__ + "static/media/facebook-icon.ddb74ee4.png";